/**
 * edt.js
 * ------
 * Sources de l'emploi du temps : indisponibilités enseignants et volumes
 * horaires par matière. Ce sont les deux entrées que le moteur consulte avant
 * de poser une grille ; le cockpit les affiche en lecture.
 *
 * Backend : core/directeur_views.py — permission IsAdminLevel, scope
 * "fail-closed" par établissement.
 */
import axiosClient from "../axiosClient";

/** GET /directeur/edt/indisponibilites/
 *  -> { jours, creneaux, enseignants, pression_par_jour, absences_longues, stats } */
export async function getEdtIndisponibilites() {
  const { data } = await axiosClient.get("/directeur/edt/indisponibilites/");
  return data || {};
}

/** GET /directeur/edt/matieres/
 *  -> { niveaux, matieres, totaux, classes_non_configurees, stats } */
export async function getEdtMatieres() {
  const { data } = await axiosClient.get("/directeur/edt/matieres/");
  return data || {};
}

/** GET /directeur/edt/conflits/ -> { semaine_debut, conflits, stats } */
export async function getEdtConflits(semaine) {
  const { data } = await axiosClient.get("/directeur/edt/conflits/", {
    params: semaine ? { semaine } : {},
  });
  return data || {};
}

/** POST /directeur/edt/cours/<id>/salle/ — déplace un cours.
 *  `salle` à null retire la salle. Le serveur refuse un créneau déjà occupé. */
export async function deplacerCoursSalle(coursId, salleId) {
  const { data } = await axiosClient.post(`/directeur/edt/cours/${coursId}/salle/`, {
    salle: salleId ?? null,
  });
  return data;
}
